// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__22jgc","content":"styles_content__2E-Mw","selectAll":"styles_selectAll__1KWXs"};